import React from "react";
import Parser from "html-react-parser";
import { v4 as generateUUID } from "uuid";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import { Paragraph } from "@tvg/design-system/web";
import { RichText, RichTextInlineComp } from "../../types";

import { ContentTextWrapper, TextContainer } from "./styled-components";
import {
  RenderRichTextInlineComp,
  RenderRichTextParagraph
} from "../richTextEditorResolver";

export interface Mark {
  type: string;
  attrs?: {
    class?: string;
  };
}

export interface RichTextContent {
  text: string;
  type: string;
  marks?: Mark[];
}

export interface ParagraphBlock {
  type: string;
  content: RichTextContent[];
}

export interface Markdown {
  type?: string;
  content?: ParagraphBlock[];
}

export interface Blok {
  _uid: string;
  markdown: Markdown;
  component: string;
  _editable?: string;
}

export interface ContentTextProps {
  bloks: Blok[];
}

const ContentText: React.FC<{ content: ContentTextProps }> = ({ content }) => {
  if (!content?.bloks?.length) return null;

  const markdownContent = content.bloks[0]?.markdown?.content;
  const markdownContentCPP = content.bloks[0]?.markdown;
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const isCPP = typeof markdownContentCPP === "string";

  const renderTextBlock = (text: string) => (
    <TextContainer key={generateUUID()} isCPP={isCPP} isMobile={isMobile}>
      <Paragraph fontFamily="regular">{Parser(text)}</Paragraph>
    </TextContainer>
  );

  return (
    <ContentTextWrapper>
      {Array.isArray(markdownContent) &&
        markdownContent.map((blok) => {
          if (blok.type !== "blok") {
            const actualText = RenderRichTextParagraph(
              blok as unknown as RichText
            );
            return typeof actualText === "string"
              ? renderTextBlock(actualText)
              : actualText;
          }
          return RenderRichTextInlineComp(
            blok as unknown as RichTextInlineComp
          );
        })}

      {typeof markdownContentCPP === "string" &&
        renderTextBlock(markdownContentCPP)}
    </ContentTextWrapper>
  );
};

export default ContentText;
